import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/brandIcons.css';
import App from './App';
import NoticeDialog from './components/modals/NoticeDialog';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <NoticeDialog />
  </React.StrictMode>
);

